import { BoardsService } from '../../../services/boardsPage/boards.service';
import { ReportsData } from '../../../services/boardsPage/reports-data';
import { sectorslist, SectorBrandData, SectorsService } from 'src/app/shared/services/sectors.service';
import { ProductItem, ProductitemService } from 'src/app/shared/services/productitem.service';
import { statuslist, StatusService } from 'src/app/shared/services/status.service';
import { Region, RegionsService } from 'src/app/shared/services/regions.service';
import { Users, SalesService } from 'src/app/shared/services/sales.service';
import * as Highcharts from 'highcharts';

import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';

import { UIChart } from 'primeng/chart';


import * as $ from 'jquery';

import { Table } from 'primeng/table';

// import * as Chart from 'chart.js'
import { Chart, ChartConfiguration, Legend } from 'chart.js';


import { min } from 'rxjs/operators';



// interface ChartData {
//   labels: string[];
//   datasets: {
//     label: string;
//     data: number[];
//     backgroundColor: string;
//     borderColor: string;
//     borderWidth: number;
//   }[];
// }
@Component({
  selector: 'app-boards',
  templateUrl: './boards.component.html',
  styleUrls: ['./boards.component.scss']
})
export class BoardsComponent implements OnInit {
  chartData2: any;
  technicalManagerOpportinitiesOptions: any;
  // change from UIChart to Chart
  @ViewChild("chart") chart: UIChart;
  @ViewChild("pieChart") pieChart: UIChart;
  @ViewChild('dt') table: Table;


  currentYear = new Date().getFullYear() + '';
  sales = 'All'
  region = 'All'
  sector = 'All'
  status = 'All'
  public quarter: string[] = ['null'];
  public year: string[] = [this.currentYear];
  public renewable: boolean = false;
  public partner: boolean = false;
  public sbmchannel: string = 'All';
  public productKind: string[] = ['SWG', 'STG']
  gstatus = 'All';
  filterIsToggled = true;

  //public yearsList ;


  public errorMsg;

  opportunitiesBriefPerm = true;
  public opportunitiesBrief: ReportsData; //{ value:0, quotaAchievement:0 , closedRevenue:0,  weight:0 }

  topFiveActivePerm = true;
  public topFiveActive: ReportsData[];
  public topFiveActiveSize = 0;
  topFiveActiveChart: any;

  public sectors: sectorslist[];
  public statusList: statuslist[];
  public regionsList: Region[];
  public items: ProductItem[];
  public salesUsers: Users[];
  public currentLoggedUserList: Users[];
  public currentLoggedUser: Users;

  piplineByOppPerm = true;
  piplineByOpp: ReportsData[];
  pipelineChart: any;
  quotaAchievementChart: any;
  revenueVsTrendChart: any;

  sssSummaryPerm = true;
  sssSummary: any;

  summaryCardPerm = false;
  sectorsSummary: ReportsData[];
  sectorPipelineSummary: SectorBrandData[] = [];

  sectorsSummaryPerm = false;
  brandsSummaryPerm = false;
  swgLicSummaryCardPerm = false;
  swgSerSummaryCardPerm = false;
  stgHWSummaryCardPerm = false;
  hasTechLeadAccess = false;
  stgSerSummaryCardPerm = false;

  brandsSummary: ReportsData[];
  brandsPipelineSummary: SectorBrandData[] = [];
  displayProductKindCheckBoxes = false;
  filterForPage = 'boards';
  chartOptions: any;
  pieChartOptions: any;
  technicalManagerData: any[] = [];

  public opportunities: any[] = [];
  public techLeads: Users[] = [];
  public selectedTechLead: string = '';
  chartOptions2: Highcharts.Options;  // Chart options
  Highcharts: typeof Highcharts = Highcharts; // Declare Highcharts property

  selectedManagerId: string = "sxsda";
  filteredOpportunities: string[] = [...this.opportunities];



  constructor(
    private cdr: ChangeDetectorRef,

    private boardsService: BoardsService,
    private sectorService: SectorsService,
    private statusService: StatusService,
    private regionService: RegionsService,
    private salesService: SalesService,
    private itemService: ProductitemService,
    private router: Router,) {

  }

  ngOnInit(): void {




    this.fetchTechLeads();
    this.fetchTechnicalManagerData();

    // if (this.selectedManagerId) {
    //   this.fetchOpportunities(this.selectedManagerId);
    // }
    // Spinner
    $("body").css("overflow-y", "hidden");



    this.getCurrentLoggedUser();
    this.retrieveSectors();
    this.retrieveItems();
    this.getAllStatus();
    this.getAllRegions();
    this.getAllSalesUsers();
    this.fetchTechnicalManagerData();

    if (this.selectedTechLead) {
      this.getOpportunitiesByTechLead(this.selectedTechLead);
    }
    this.filteredOpportunities = [...this.opportunities]; // Ensure this is updated
    this.cdr.detectChanges();
    (
      async () => {

        await this.delay(1000);

        if (this.currentLoggedUser && this.currentLoggedUser.role && (this.currentLoggedUser.role.roleId == 8 || this.currentLoggedUser.role.roleId == 10 || this.currentLoggedUser.role.roleId == 9 || this.currentLoggedUser.role.roleId == 11 || this.currentLoggedUser.role.roleId == 12 || this.currentLoggedUser.role.roleId == 13)) {

          this.opportunitiesBriefPerm = false;
          this.summaryCardPerm = true;
          this.sectorsSummaryPerm = true;
          this.brandsSummaryPerm = true;
          this.swgLicSummaryCardPerm = true;
          this.swgSerSummaryCardPerm = true;
          this.stgHWSummaryCardPerm = true;
          this.stgSerSummaryCardPerm = true;

          if (this.currentLoggedUser.role.roleId == 12 || this.currentLoggedUser.role.roleId == 13) {
            this.displayProductKindCheckBoxes = true;
          }

          if (this.currentLoggedUser.role.roleId == 8 || this.currentLoggedUser.role.roleId == 10) {
            this.swgLicSummaryCardPerm = true;
            this.swgSerSummaryCardPerm = true;
            this.stgHWSummaryCardPerm = false;
            this.stgSerSummaryCardPerm = false;
          }

          if (this.currentLoggedUser.role.roleId == 11 || this.currentLoggedUser.role.roleId == 9) {
            this.swgLicSummaryCardPerm = false;
            this.swgSerSummaryCardPerm = false;
            this.stgHWSummaryCardPerm = true;
            this.stgSerSummaryCardPerm = true;
          }
        }
        else {
          this.opportunitiesBriefPerm = true;
          this.summaryCardPerm = false;
          this.sectorsSummaryPerm = false;
          this.brandsSummaryPerm = false;
          this.swgLicSummaryCardPerm = false;
          this.swgSerSummaryCardPerm = false;
          this.stgHWSummaryCardPerm = false;
          this.stgSerSummaryCardPerm = false;
        }

        this.drowCards();
        // Do something after
        //console.log('after delay')

        // Spinner
        $(".spinner-container").fadeOut();
        $("body").css("overflow-y", "auto");
      })();
    //this.drowCards();

  }

  fetchTechLeads(): void {
    this.salesService.retrieveTechLeads().subscribe(
      (data: any[]) => {
        this.techLeads = data;
        // console.log(' --------------> Tech Leads:', this.techLeads);
      },
      (error) => {
        console.error('Error fetching tech leads', error);
      }
    );
  }
  getTechLeadLabel(techLead: any): string {
    return `${techLead.firstName} ${techLead.lastName}`;
  }

  onTechLeadChange(selectedUser: any): void {
    if (!selectedUser || !selectedUser.value) {
      this.onTechLeadClear();
      return;
    }
  
    this.opportunities = [];
    this.filteredOpportunities = [];
  
    const userId = selectedUser.value;
  
    this.getOpportunitiesByTechLead(userId);
  }

  onTechLeadClear(): void {
    this.opportunities = [];
    // console.log('Cleared Opportunities:', this.opportunities);
  }
  onSearch(event: any) {

    const query = event.target.value.toLowerCase();
    this.filteredOpportunities = this.opportunities.filter(opportunity =>
      opportunity.toLowerCase().includes(query)
    );
    this.cdr.detectChanges(); // Manually trigger change detection
  }
  getOpportunitiesByTechLead(userId: string): void {
    this.boardsService.getOpportunities(userId).subscribe(opportunities => {
      this.opportunities = opportunities;
      this.filteredOpportunities = [...this.opportunities];
      this.cdr.detectChanges(); // Trigger change detection
    }, error => {
      this.errorMsg = error;
    });
  }
  

  // onIdChange(event: Event): void {
  //   const selectedId = (event.target as HTMLSelectElement).value;
  //   if (selectedId) {
  //     this.fetchOpportunities(selectedId);
  //   }
  // }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getCurrentLoggedUser() {
    let useremail = sessionStorage.getItem('loginUserName');

    return this.salesService.findUserByEmail(useremail).subscribe(
      response => {
        //console.log("getCurrentLoggedUser : "+ response);
        //console.log(response);
        this.currentLoggedUserList = response;
        this.currentLoggedUser = this.currentLoggedUserList[0];
        this.hasTechLeadAccess = this.currentLoggedUser.role.techLeadAccess;
        //console.log( this.currentLoggedUser );
      },
      error => this.errorMsg = error
    );

  }

  retrieveItems() {

    return this.itemService.getProductItemsInReportShow().subscribe(
      response => {
        //console.log("retrieveProductItems : "+ response);
        //console.log(response);
        this.items = response;
      },
      error => this.errorMsg = error
    );
  }

  retrieveSectors() {

    return this.sectorService.retriveSectors().subscribe(
      response => {
        //console.log("retrieveSectors : "+ response);
        //console.log(response);
        this.sectors = response;
      },
      error => this.errorMsg = error
    );
  }
  getAllSalesUsers() {
    return this.salesService.findSalesUsersByManager(this.region, this.sector).subscribe(
      response => {
        //console.log("findSalesUsersByManager : "+ response);
        //console.log(response);
        this.salesUsers = response;

        let salesUsersUnderManager: Users[] = [];
        this.salesUsers.forEach((data, index) => {
          let user = <Users>data;
          //if (user.email !== sessionStorage.getItem('loginUserName')) {
            salesUsersUnderManager.push(user);
         // }
        });
        this.salesUsers = salesUsersUnderManager;

      },
      error => this.errorMsg = error
    );

  }


  getAllRegions() {
    return this.regionService.getRegions().subscribe(
      response => {
        //console.log("getAllRegions : "+ response);
        //console.log(response);
        this.regionsList = response;
      },
      error => this.errorMsg = error
    );
  }

  getAllStatus() {
    return this.statusService.getstatusList().subscribe(
      response => {
        //console.log("getAllStatus : "+ response);
        //console.log(response);
        this.statusList = response;
      },
      error => this.errorMsg = error
    );
  }

  public resetForm(formGroup: UntypedFormGroup) {
    let control: AbstractControl = null;
    formGroup.reset();
    formGroup.markAsUntouched();
    Object.keys(formGroup.controls).forEach((name) => {
      control = formGroup.controls[name];
      control.setErrors(null);
    });
  }

  public onResetClick(event: any) {
    //console.log("on reset clicked of parent component called.......");
    this.sales = 'All'
    this.region = 'All'
    this.sector = 'All'
    this.status = 'All'
    this.quarter = null
    this.year = [this.currentYear]
    this.renewable = false;
    this.productKind = ['SWG', 'STG']
    this.gstatus = 'All'
    this.filterIsToggled = true;
    this.sbmchannel = 'All'
    //console.log(this.myForm);
    //this.boardsService.setFilters(this.region, sales , sector , status , year, quarter , productKind , gstatus, renewable,sbmchannel);
    this.boardsService.setFilters(this.region, this.sales, this.sector, this.status, this.year, this.quarter, this.productKind, this.gstatus, this.renewable, this.sbmchannel, this.partner);
    this.drowCards();
  }

  public filterClicked(event: any) {
    this.filterIsToggled = !this.filterIsToggled;
    var element = document.getElementById("chart-table");
    //console.log('filterchicked');
    //console.log(element.classList);
    if (element.classList) {
      element.classList.toggle("col-md-9");
    } else {
      // For IE9
      var classes = element.className.split(" ");
      var i = classes.indexOf("col-md-9");

      if (i >= 0)
        classes.splice(i, 1);
      else
        classes.push("col-md-9");
      element.className = classes.join(" ");
    }
  }

  public onCheckBoxClicked(event: any) {
    //console.log("on checkbox clicked of parent component called.......");
    //console.log(event);
    //console.log(event.target);
    //console.log(event.target.id);

    var yearul = <HTMLInputElement>document.getElementById("yearul");
    var inputs = yearul.getElementsByTagName("input");
    for (let index = 0; index < inputs.length; index++) {
      const element = inputs[index];
      //console.log(element);
      if (element.checked) {
        //console.log(element.value);
        this.year.push(element.value);
      }
      else {
        this.deleteYear(element.value);
      }

    }

    if (event.target.id == "year") {

      if (event.target.checked) {
        this.year.push(event.target.value);
      }
      else {
        // //console.log('calling delete year.....');
        this.deleteYear(event.target.value);
      }

    }
    else if (event.target.id == "renewable") {

      if (event.target.checked) {
        this.renewable = true;
      }
      else {
        this.renewable = false;
      }

    }
    else if (event.target.id == "partner") {

      if (event.target.checked) {
        this.partner = true;
      }
      else {
        this.partner = false;
      }

    }
    else if (event.target.id == "quarter") {
      //this.quarter = [];
      if (event.target.checked) {
        this.deleteQuarter('null');
        this.quarter.push(event.target.value);
      }
      else {
        // //console.log('calling delete year.....');
        this.deleteQuarter(event.target.value);
      }
      this.quarter = Array.from(new Set(this.quarter));
      if (this.quarter.length <= 0) {
        this.quarter.push('null');
      }
      //console.log(this.quarter);
    }
    else if (event.target.id == "stgType" || event.target.id == "swgType") {
      //this.quarter = [];

      this.deleteProductKind('SWG');
      this.deleteProductKind('STG');

      var stgBox = <HTMLInputElement>document.getElementById("stgType");
      var swgBox = <HTMLInputElement>document.getElementById("swgType");

      if (stgBox.checked) {
        this.productKind.push('STG');
        this.stgHWSummaryCardPerm = true;
        this.stgSerSummaryCardPerm = true;
      }
      else {
        this.deleteProductKind('STG');
        this.stgHWSummaryCardPerm = false;
        this.stgSerSummaryCardPerm = false;
      }

      if (swgBox.checked) {
        this.productKind.push('SWG');
        this.swgLicSummaryCardPerm = true;
        this.swgSerSummaryCardPerm = true;
      }
      else {
        this.swgLicSummaryCardPerm = false;
        this.swgSerSummaryCardPerm = false;
        this.deleteProductKind('SWG');
      }
    }
    this.productKind = Array.from(new Set(this.productKind));
    if (this.productKind.length <= 0) {
      this.productKind.push('SWG');
      this.productKind.push('STG');
      this.swgLicSummaryCardPerm = true;
      this.swgSerSummaryCardPerm = true;
      this.stgHWSummaryCardPerm = true;
      this.stgSerSummaryCardPerm = true;
    }
    //console.log(this.productKind);

    this.year = Array.from(new Set(this.year));
    if (this.year.length <= 0) {
      this.year.push(this.currentYear);
    }
    //console.log(this.year);
    //console.log('checking stg swg .....');
    //console.log(this.swgLicSummaryCardPerm);
    //console.log(this.swgSerSummaryCardPerm);


    this.boardsService.setFilters(this.region, this.sales, this.sector, this.status, this.year, this.quarter, this.productKind, this.gstatus, this.renewable, this.sbmchannel, this.partner);
    this.drowCards();
    ////console.log(event.target.style);
  }

  deleteProductKind(msg: string) {

    const index: number = this.productKind.indexOf(msg);
    if (index !== -1) {
      this.productKind.splice(index, 1);
    }

  }

  deleteQuarter(msg: string) {

    const index: number = this.quarter.indexOf(msg);
    if (index !== -1) {
      this.quarter.splice(index, 1);
    }

  }
  deleteYear(msg: string) {

    const index: number = this.year.indexOf(msg);
    if (index !== -1) {
      this.year.splice(index, 1);
    }

  }
  public onDropDownClicked(obj: any) {
    //console.log(obj);
    //console.log(obj.target.name);
    //console.log(obj.target.value);
    //console.log(obj.target);

    if (obj.target.name != undefined) {
      if (obj.target.name == "status") {
        this.status = obj.target.value;
      }
      if (obj.target.name == "genericstatus") {
        this.gstatus = obj.target.value;
      }
      if (obj.target.name == "sbmchannel") {
        this.sbmchannel = obj.target.value;
      }
      if (obj.target.name == "region") {
        this.region = obj.target.value;
        this.getAllSalesUsers();
      }
      if (obj.target.name == "sector") {
        this.sector = obj.target.value;
        this.getAllSalesUsers();
      }
      if (obj.target.name == "sales") {
        this.sales = obj.target.value;
      }

      if (obj.target.name == 'year') {
        this.year.push(obj.target.value);
      }
      this.year = Array.from(new Set(this.year));
    }


    //console.log(this.year);
    this.boardsService.setFilters(this.region, this.sales, this.sector, this.status, this.year, this.quarter, this.productKind, this.gstatus, this.renewable, this.sbmchannel, this.partner);
    this.drowCards();
  }

  public drowCards() {

    //console.log('inside drowCards()');
    //console.log(this.currentLoggedUser);
    //console.log(this.currentLoggedUser[0]);

    if (this.opportunitiesBriefPerm) {

      this.fillOpportunitiesBrief();
    }

    //console.log("this.summaryCardPerm : " + this.summaryCardPerm);

    this.fillTopFiveActiveOpportunities();

    this.fillPiplineByOpportunitiesStatus();

    this.fillQuotaAchievementChart();

    this.fillRevenueVsTrendChart();

    this.fillSssSummary();

    this.fillsectorsSummary();

    this.fillBrandsSummary();

    //this.drawChart();
  }

  fillRevenueVsTrendChart() {

    this.revenueVsTrendChart = {

      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'First Dataset',
          data: [65, 59, 80, 81, 56, 55, 40],
          fill: false,
          borderColor: '#4bc0c0'
        },
        {
          label: 'Second Dataset',
          data: [28, 48, 40, 19, 86, 27, 90],
          fill: false,
          borderColor: '#565656'
        }
      ]
    };

  }

  fillQuotaAchievementChart() {

    this.quotaAchievementChart = {
      labels: [
        "NIC",
        "MOJ",
        "Rayed Bank ",
        "Not Yet",
        "Rajhi Bank"
      ],
      datasets: [{
        label: 'Quota Achievement',
        data: [
          12,
          19,
          18,
          5,
          6
        ],
        backgroundColor: [
          'rgba(105, 105, 105, 0.2)',
          'rgba(105, 105, 105, 0.2)',
          'rgba(105, 105, 105, 0.2)',
          'rgba(105, 105, 105, 0.2)',
          'rgba(105, 105, 105, 0.2)'
        ],
        borderColor: [
          'rgba(105, 105, 105,1)',
          'rgba(105, 105, 105, 1)',
          'rgba(105, 105, 105, 1)',
          'rgba(105, 105, 105, 1)',
          'rgba(105, 105, 105, 1)'
        ],
        borderWidth: 1
      }]
    };

  }


  public fillOpportunitiesBrief() {
    return this.boardsService.callBriefService().subscribe(
      response => {
        //console.log("fillOpportunitiesBrief : "+ response);
        //console.log(response);
        this.opportunitiesBrief = response;

        if (this.opportunitiesBrief.closedRevenue == null) {
          this.opportunitiesBrief.closedRevenue = 0;
        }
        if (this.opportunitiesBrief.quotaAchievement == null) {
          this.opportunitiesBrief.quotaAchievement = 0;
        }
        // this.opportunitiesBrief.value = response.value;
        // this.opportunitiesBrief.quotaAchievement = response.quotaAchievement;
        // this.opportunitiesBrief.closedRevenue = response.closedRevenue;
        // this.opportunitiesBrief.weight = response.weight;
      },
      error => this.errorMsg = error
    );
  }

  fillTopFiveActiveOpportunities() {

    return this.boardsService.callTopFiveActiveOpportunities().subscribe(
      response => {
        //console.log("topfiveopportunities : "+ response);
        this.topFiveActive = response;
        //console.log(this.topFiveActive);
        this.topFiveActiveSize = this.topFiveActive.length;
        //console.log(" this.topFiveActiveSize : "+ this.topFiveActiveSize);
        this.drawChart();


      },
      error => this.errorMsg = error
    );
  }
  public courses = [];

  namesOppId = [];
  chartLabels: any[] = [];
  chartData: any[] = [];
  chartOppName: any[] = [];



  drawChart() {
    this.namesOppId = [];
    this.chartLabels = [];
    this.chartData = [];

    this.chartOppName = [];
    //console.log(this.topFiveActive);
    this.topFiveActive.forEach((data, index) => {
      let castedtype = <ReportsData>data;
      //console.log(index + ","+ castedtype);
      //console.log(parseInt(""+castedtype.value).toLocaleString());
      this.chartLabels[index] = castedtype.customerName;
      this.chartData[index] = castedtype.value;
      this.chartOppName[index] = castedtype.statusName;
      this.namesOppId[index] = castedtype.statusId;
      //console.log(this.chartOppName);

      this.courses.push({
        label: castedtype.statusName,
        data: castedtype.value,
        backgroundColor: "#FF6384",
        hoverBackgroundColor: "#FF6384"
      });
    });

    // this.chart.options =
    // {
    //   legend: {
    //     display: false
    //   },
    //   scales: {
    //     yAxes: [{
    //       ticks: {
    //         beginAtZero: true,
    //         callback: function (value, index, values) {
    //           if (parseInt(value) >= 1000) {
    //             return /*'$' +*/ value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //           } else {
    //             return /*'$' +*/ value;
    //           }
    //         }
    //       }
    //     }]
    //   },
    //   tooltips:
    //   {
    //     enabled: true,
    //     mode: 'single',
    //     callbacks:
    //     {
    //       title: ((tooltipItem) => {
    //         /*//console.log('tooltips options title function called.......');
    //         //console.log(tooltipItem);
    //         //console.log(tooltipItem[0]);
    //         //console.log(tooltipItem[0]['index']);
    //         //console.log(this.chartOppName);
    //         */
    //         return this.chartOppName[tooltipItem[0]['index']];
    //       }),
    //       label: ((tooltipItem) => {

    //         let index = tooltipItem.index;
    //         let dataArr: string[] = [];
    //         // dataArr.push(this.chartOppName[index]);
    //         //  //console.log('tooltip new callback function');
    //         //console.log(tooltipItem);
    //         //console.log(index);
    //         //console.log(this.chartOppName);
    //         // let label = this.chartLabels[index];
    //         dataArr.push(tooltipItem.yLabel.toLocaleString());
    //         return dataArr;
    //       })
    //     }
    //   }
    // }


    //angular 16

    this.chart.options = {
      plugins: {
        legend: {
          display: false
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            callback: function (value) {
              if (parseInt(String(value)) >= 1000) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return value;
              }
            }
          }
        }
      }
    };




    this.topFiveActiveChart = {
      labels: this.chartLabels,
      datasets: [
        {
          //label: this.chartOppName,
          data: this.chartData,
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#FF5733",
            "#33C3FF",
            "#60AF11",
            "#42D2DA",
            "#D6E946",
            "#C3CEF7",
            "#33C3FF"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#FF5733",
            "#33C3FF",
            "#60AF11",
            "#42D2DA",
            "#D6E946",
            "#C3CEF7",
            "#33C3FF"
          ]
        }]
    };


  }

  fillPiplineByOpportunitiesStatus() {
    return this.boardsService.callfillPiplineByOpportunitiesStatus().subscribe(
      response => {
        //console.log("fillPiplineByOpportunitiesStatus : "+ response);
        //console.log(response);
        this.piplineByOpp = response;
        // this.opportunitiesBrief.value = response.value;
        // this.opportunitiesBrief.quotaAchievement = response.quotaAchievement;
        // this.opportunitiesBrief.closedRevenue = response.closedRevenue;
        // this.opportunitiesBrief.weight = response.weight;
        this.drawPieChart();
      },
      error => this.errorMsg = error
    );
  }

  drawPieChart() {
    //throw new Error("Method not implemented.");

    let chartLabels: any[] = [];
    let chartData: any[] = [];
    let piechartOppName: any[] = [];

    this.piplineByOpp.forEach((data, index) => {
      let reportsData = <ReportsData>data;
      //console.log(index + ","+ reportsData);
      chartLabels[index] = reportsData.statusName;
      chartData[index] = reportsData.closedRevenue;
      piechartOppName[index] = reportsData.value;
      //console.log(piechartOppName);
    });


    this.pieChart.options =
    {
      legend: {
        position: 'right',
        labels: {
          generateLabels: function (chart) {
            var data = chart.data;
            var backgroundColor: [
              "#FF6384",
              "#36A2EB",
              "#FFCE56",
              "#60AF11"
            ];
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                // var meta = chart.getDatasetMeta(0);
                // var ds = data.datasets[0];
                // var arc = meta.data[i];
                // var custom = arc && arc.custom || {};
                // var theHelp = Chart.helpers;
                // var getValueAtIndexOrDefault = theHelp.getValueAtIndexOrDefault;
                // var arcOpts = chart.options.elements.arc;
                // //var fill = backgroundColor[i] ;
                // var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                // var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                // var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
                // console.log("i: " + i);
                // console.log(piechartOppName);

                const meta = chart.getDatasetMeta(0);
                const ds = data.datasets[0];
                const arc = meta.data[i];
                const custom = arc && arc.custom || {};
                const arcOpts = chart.options.elements.arc;

                const fill = custom.backgroundColor || ds.backgroundColor[i] || arcOpts.backgroundColor;
                const stroke = custom.borderColor || ds.borderColor[i] || arcOpts.borderColor;
                const bw = custom.borderWidth || ds.borderWidth[i] || arcOpts.borderWidth;


                return {
                  // And finally :
                  //text: ds.data[i] + " " + label + " with total " +parseInt(pricesData[i]).toLocaleString() + " USD",
                  text: /*piechartOppName[i] + " " + */ label,
                  fillStyle: fill,
                  strokeStyle: stroke,
                  lineWidth: bw,
                  hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        }
      },


      tooltips:
      {
        enabled: true,
        mode: 'single',
        callbacks:
        {
          title: ((tooltipItem) => {
            //console.log('tooltips options title function called.......');
            //console.log(this.chartOppName);

            return "";//piechartOppName[tooltipItem[0]['index']];
          }),
          label: ((tooltipItem) => {

            let index = tooltipItem.index;
            let dataArr: string[] = [];
            // console.log(tooltipItem);
            //console.log(piechartOppName);
            // console.log(chartLabels);
            // console.log(chartData);

            // console.log(tooltipItem.index);

            // dataArr.push(this.chartOppName[index]);
            //  //console.log('tooltip new callback function');
            //console.log(tooltipItem);
            //console.log(index);
            //console.log(this.chartOppName);
            // let label = this.chartLabels[index];
            //dataArr.push(tooltipItem.yLabel.toLocaleString());
            let val: number = parseInt(chartData[tooltipItem.index]);
            let valu = val.toLocaleString();
            //console.log(val);
            //console.log(valu);
            dataArr.push(chartLabels[tooltipItem.index] + " " + valu);
            return dataArr;
          })
        }
      }
    }

    this.pipelineChart = {
      labels: chartLabels,
      datasets: [
        {
          //label: this.piechartOppName,
          data: chartData,
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#60AF11"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#60AF11"
          ]
        }

      ]
    };



  }

  // method to ckech if the user mail is tkhattab@sbm.com.sa

  public isDeliveryManager() {
    let useremail = sessionStorage.getItem('loginUserName');
    if (useremail == 'tkhattab@sbm.com.sa') {
      return true;
    } else {
      return false;
    }
  }



  fillBrandsSummary() {


    return this.boardsService.callBrandsSummary().subscribe(
      response => {
        //console.log("sectorsSummary : "+ response);
        //console.log(response);
        this.brandsSummary = response;

        this.brandsPipelineSummary = [];
        this.items.forEach((itemData, index) => {

          let sector = <ProductItem>itemData;
          let sbData: SectorBrandData = {
            name: itemData.item,
            pipelineValue: 0,
            weightedValue: 0
          }

          this.brandsSummary.forEach((data, index) => {

            let reportsData = <ReportsData>data;
            if (itemData.item == "" + reportsData.counter) {
              //sectorData.
              sbData.name = itemData.item;
              sbData.pipelineValue = reportsData.value;
              sbData.weightedValue = reportsData.weight;
              return;
            }
          });
          // //console.log(sbData);
          this.brandsPipelineSummary.push(sbData);
        });

        //console.log("sectorPipelineSummary : ");
        // //console.log(this.sectorPipelineSummary);
      },
      error => this.errorMsg = error
    );
    //throw new Error("Method not implemented.");
  }

  public itemsData: ReportsData[] = [];

  fillsectorsSummary() {
    return this.boardsService.callSectorSummary().subscribe(
      response => {
        //console.log("sectorsSummary : "+ response);
        //console.log(response);
        this.sectorsSummary = response;
        this.sectorPipelineSummary = [];
        this.sectors.forEach((sectorData, index) => {

          let sector = <sectorslist>sectorData;
          let sbData: SectorBrandData = {
            name: sectorData.sector,
            pipelineValue: 0,
            weightedValue: 0
          }

          this.sectorsSummary.forEach((data, index) => {

            let reportsData = <ReportsData>data;
            if (sectorData.sector == "" + reportsData.counter) {
              //sectorData.
              sbData.name = sectorData.sector;
              sbData.pipelineValue = reportsData.value;
              sbData.weightedValue = reportsData.weight;
              return;
            }
          });
          // //console.log(sbData);
          this.sectorPipelineSummary.push(sbData);
        });


      },
      error => this.errorMsg = error
    );
    //throw new Error("Method not implemented.");
  }


  fillSssSummary() {

    return this.boardsService.callfillSSSSummary().subscribe(
      response => {

        this.sssSummary = response;
      },
      error => this.errorMsg = error
    );
  }


  selectData(e: any) {

    //console.log(e.dataset);
    //console.log(e.element);
    //console.log(e.element._datasetIndex);
    //console.log(e.element._index);
    // this.router.navigate(['/leads/', { id: this.namesOppId[e.element._index]}]);
    let filter = { id: this.namesOppId[e.element._index] };
    let id = this.namesOppId[e.element._index];
    this.router.navigate(['/leads/'], { queryParams: filter, skipLocationChange: true });
    history.pushState(filter, "", "/leads/");
    //console.log(this.namesOppId[e.element._index]);
    //console.log(this.chart);
    //console.log(this.chartOppName);
  }


  fetchTechnicalManagerData() {

    this.boardsService.callTechLeadsOpportunitiesCount().subscribe(
      (data: any[]) => {
        this.technicalManagerData = data;
        this.createChart();

      },
      (error) => {
        console.error('Error fetching technical manager data:', error);
      }
    );
  }

  createChart() {
    const labels = this.technicalManagerData.map(item => item.techLeadName);
    const data = this.technicalManagerData.map(item => item.opportunitiesCount);

    const backgroundColors = [
      "#FF6384",
      "#36A2EB",
      "#FFCE56",
      "#FF5733",
      "#33C3FF",
      "#60AF11",
      "#42D2DA",
      "#D6E946",
      "#C3CEF7",
      "#33C3FF"
      // Add more colors if needed
    ];

    const borderColors = [
      "#FF6384",
      "#36A2EB",
      "#FFCE56",
      "#FF5733",
      "#33C3FF",
      "#60AF11",
      "#42D2DA",
      "#D6E946",
      "#C3CEF7",
      "#33C3FF"
    ];

    this.technicalManagerOpportinitiesOptions = {
      plugins: {
        legend: {
          display: false
        }
      },
      scales: {
        x: {
          barPercentage: 0.1
        },
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1,
            precision: 0
          }
        }
      }
    };
    this.chartData2 = {
      labels: labels,
      datasets: [{
        label: 'Opportunities Count',
        data: data,
        backgroundColor: backgroundColors.slice(0, labels.length),
        borderColor: borderColors.slice(0, labels.length),
        borderWidth: .3
      }]
    };



  }



}


